import { numberConvert } from "@website/utils/number-convert";
interface Properties {
  rules: Array<{ rule: string; penalty: string }>;
}

export function CancellationPolicyTable({ rules }: Properties) {
  return (
    <div className="border-dim-surfaces flex flex-col overflow-hidden rounded border text-sm lg:text-base">
      <div className="grid grid-cols-6 border-b">
        <div className="bg-dim-background col-span-4 flex items-center justify-start p-4">
          شرایط زمانی کنسلی
        </div>
        <div className="bg-dim-background col-span-2 flex items-center justify-center border-r p-4">
          جریمه
        </div>
      </div>
      {rules.map((item, index) => (
        <div
          className={`grid grid-cols-6 ${
            rules.length - 1 === index ? "" : "border-b"
          }`}
          key={item.rule}
        >
          <div className="col-span-4 flex items-center justify-start p-4">
            {numberConvert(item.rule, { locale: "fa" })}
          </div>
          <div className="col-span-2 flex items-center justify-center border-r p-4">
            {numberConvert(item.penalty, { locale: "fa" })}
          </div>
        </div>
      ))}
    </div>
  );
}
